module.exports = __webpack_public_path__ + "img/ipad-pro.df7d3430.png";